/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Box, Button, Divider, Typography } from "@mui/material";
import useAxiosPrivate from "contexts/interceptors/axios";
import SubmissionsTable from "./SubmissionsTable";
import { useStateContext } from "../../../../../contexts/ContextProvider";

export default function Submissions() {
  const { auth } = useStateContext();
  const axiosPrivate = useAxiosPrivate();
  const [submissionData, setSubmissionData] = useState([]);
  const [selectedSubmission, setSelectedSubmission] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleGetAll = () => {
    setLoading(true);
    setError("");

    axiosPrivate
      .get(`/I-Abide/getAllSubmissions`)
      .then((res) => {
        // Check if the user role is "admin"
        if (
          auth?.role === "admin" ||
          auth?.role === "cid -chief" ||
          auth?.role === "osds" ||
          auth?.role === "asds"
        ) {
          // If admin, set all submissions
          setSubmissionData(res?.data);
        } else if (
          auth?.role === "education program supervisor" ||
          auth?.role === "education program specialist 2" ||
          auth?.role === "senior education program specialist" ||
          auth?.role === "chief education supervisor" ||
          auth?.role === "accountant 3" ||
          auth?.role === "project development officer 1" ||
          auth?.role === "project development officer 2" ||
          auth?.role === "administrative officer 2" ||
          auth?.role === "administrative officer 4" ||
          auth?.role === "administrative officer 5"
        ) {
          // If not admin, filter by officeId
          const filtered = res?.data.filter(
            (submission) => submission.postedBy === auth?.username
          );
          setSubmissionData(filtered);
        } else {
          const filtered = res?.data.filter(
            (submission) => submission.relatedOfficeId === auth?.officeId
          );
          setSubmissionData(filtered);
        }
      })
      .catch((err) => {
        setError(err?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetAll();
  }, []);

  return (
    <Box
      sx={{
        p: "20px",
      }}
    >
      <Box
        borderRadius="10px"
        boxShadow="3px 2px 15px 3px rgba(100, 100, 100, 0.8)"
        p="1rem"
        sx={{ backgroundColor: "rgba(240, 240, 240, 1)" }}
      >
        <Divider>
          <Typography
            sx={{
              textTransform: "uppercase",
              fontSize: "25px",
            }}
          >
            Submitted Documents
          </Typography>
        </Divider>
        <Box>
          {error}
          <SubmissionsTable
            data={submissionData}
            setSelectedData={setSelectedSubmission}
            loadingState={loading}
            updateTableFunction={handleGetAll}
          />
        </Box>

        <Divider
          variant="middle"
          sx={{ borderTopWidth: "1px", borderTopColor: "grey" }}
        />
      </Box>
    </Box>
  );
}
